import React, { useEffect } from "react";
import HeroSection from "../Hero/HeroSection";
import WhatYouWillGain from "../WhatYouWillGain/WhatYouWillGain";
//import './Home.css'
import FAQ from "../Faqs/FAQ";
import WeOffer from "../WeOffer/WeOffer";
import MockInterview from "../MockInterview/MockInterview";
import Testimonials from "../Testimonials/Testimonials";
import YourPreparation from "../YourPrepartion/YourPreparation";
import DomainAndIndustry from "../DomainAndIndustry/DomainAndIndustry";
import ServiceCards from "../FourBox/FourBox";

const Home = () => {
  
  useEffect(() => {
    document.title = "Codequeue - Connect with Experts for Personalized Guidance";
    window.scrollTo({top:'0', behavior:'smooth'})
  }, []);

  return (
    <div className="home-page"
    style={{
      marginTop: "var(--navbar-height)",
      overflow: "hidden",
      background: "linear-gradient(45deg, rgba(0, 128, 255, 0.1), rgba(0, 255, 128, 0.1), rgba(255, 0, 128, 0.1))"
    }}>
      <HeroSection/>
      <WhatYouWillGain/>
      <ServiceCards/>
      <MockInterview/>
      <WeOffer/>
      <DomainAndIndustry/>
      <YourPreparation/>
      <Testimonials/>
      <FAQ/>
    </div>
  );
};

export default Home;
